var map = {
	"./webspecial_food_spargel_cn.webm": 2507,
	"./webspecial_food_spargel_de.webm": 4477,
	"./webspecial_food_spargel_en.webm": 4545,
	"./webspecial_food_spargel_ja.webm": 1239
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1061;